import type { FC } from 'react'
import cx from 'classnames'

import styles from './ButtonSpinner.module.css'

type Props = {}

export const ButtonSpinner: FC<Props> = () => {
  return (
    <div className={cx(styles.root)}></div>
  )
}
